




































































































// Libraries
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class MatchForm extends Vue {
  @Prop() readonly form!: { [key: string]: unknown }
  @Prop() readonly errors!: { [key: string]: string[] }
  @Prop() readonly sports!: string[]

  @Prop({ default: false }) readonly showSport!: boolean

  kickoffTimePicker = false
  kickoffDatePicker = false
}
